<div fxLayout="column" fxFlexFill *ngIf="!loader">

    <div class="divider layout-padd-2 title-filter-date" ngClass.xs="layout-padd-5" fxLayoutAlign="start center"
        fxLayoutGap="10px" #pageTitle>

        <button mat-icon-button (click)="goBack()">
            <mat-icon>arrow_back</mat-icon>
        </button>

        <div fxLayout="column">
            <span class="mat-title">{{currMerchant.denomination | capitalize | descFilter: 20}}</span>
            <span class="mat-title boldest">{{'refillsComponent.title'| translate}}</span>
        </div>

        <div fxLayoutAlign="center center" class="filter-date-vignette primary clicked"
            (click)="this.filterDateAnimFlag = !this.filterDateAnimFlag" fxHide fxShow.xs>
            <i class="material-icons" *ngIf="!filterDateAnimFlag" style="color:white;">date_range</i>
            <i class="material-icons" *ngIf="filterDateAnimFlag" style="color:white;">keyboard_arrow_up</i>
        </div>

    </div>

    <div class="divider layout-padd-2" fxHide.xs>
        <app-filter-date-from-to [type]="'refills'" [merchant]="currMerchant" (setDataEvent)="setRefills($event)"
            (setLoaderEvent)='setRefillsLoader($event)'>
        </app-filter-date-from-to>
    </div>

    <div [@toggleFilterDate]="getToggleFilterDate" class="cont-filter-date-fix" [ngStyle]="{'top.px': titlePositionTop}"
        fxHide fxShow.xs>

        <div class="layout-padd-2">
            <app-filter-date-from-to [type]="'refills'" [merchant]="currMerchant" (setDataEvent)="setRefills($event)"
                (setLoaderEvent)='setRefillsLoader($event)'>
            </app-filter-date-from-to>
        </div>

    </div>

    <div fxFlex class="scrolled">

        <div class="scrolled-y">

            <table mat-table [dataSource]="dataSource" class="full-w clicked" matSort>

                <ng-container matColumnDef="date">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'refillsComponent.doit'| translate}} </th>
                    <td mat-cell *matCellDef="let recharge">
                        {{recharge.date | dateFilter:"DD-MM-YYYY"}} | {{recharge.date | dateFilter:"HH:mm"}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="value">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'refillsComponent.value'| translate}}  </th>
                    <td mat-cell *matCellDef="let recharge">
                        <div fxLayout="row">
                           
                            <div>
                                {{recharge.value_str}}
                            </div>
                            <mat-icon *ngIf="recharge.is_fidelity_gain"
                            style="    position: relative;
                            top: -10px;
                            left: 8px;">loyalty
                        </mat-icon>
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="print">

                    <th mat-header-cell *matHeaderCellDef> </th>
                    <td mat-cell *matCellDef="let recharge">
                        <!-- class="myDisabledUserKey" -->
                        <div fxLayoutAlign="center center" >
                            <mat-icon class="great-ico clicked" (click)="goInvoiceRecharge(recharge)"
                                matTooltip="{{'fidelityComponent.print'|translate}}" matTooltipPosition="below"
                                [matTooltipDisabled]="media.isActive('xs')" angulartics2On="click"
                                angularticsAction="openPrintRecharge"
                                angularticsCategory="clientRefills">print</mat-icon>
                        </div>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            </table>

            <div fxLayoutAlign="center center" class="layout-padd" *ngIf="!refillsLoader && dataSource.data.length < 1">
                <span class="mat-subheading-1">{{'refillsComponent.noRech'| translate}}</span>
            </div>

            <app-popup-loader [flagLoading]="refillsLoader" [size]="30"
                [statusMessage]="'refillsComponent.messageLoaderGetRefill'| translate" [type]="'line'"></app-popup-loader>

        </div>

        <mat-paginator [pageSizeOptions]="[10, 20, 50, 100]" showFirstLastButtons></mat-paginator>

    </div>

</div>

<app-popup-loader [flagLoading]="loader" [size]="30" [statusMessage]="statusMessage">
</app-popup-loader>